/**
 * Когда показывать вводный тур: сразу после первого входа, один раз.
 *
 * Ворота стоят в `Shell`, поэтому тур не ждёт первого урока: ученик вошёл —
 * и сразу видит, что есть в приложении. На приветствии, онбординге и входе
 * тур молчит: там ещё идёт знакомство. Флаг — в профиле на сервере;
 * закрытый тур прячется сразу, не дожидаясь ответа.
 */

import { AnimatePresence } from 'framer-motion';
import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { fetchProfile, markTutorialSeen } from '../../api/onboarding';
import { isPublicPath } from '../../app/navigation';
import { isSignedIn, useUserStore } from '../../store/userStore';
import { TutorialModal } from './TutorialModal';

export function TutorialGate() {
  const location = useLocation();
  const userId = useUserStore((state) => state.userId);
  const signedIn = useUserStore(isSignedIn);
  const [open, setOpen] = useState(false);
  // Гость, приветствие, онбординг и вход — не место для тура.
  const active = signedIn && userId.length > 0 && !isPublicPath(location.pathname);

  useEffect(() => {
    if (!active) return undefined;
    let cancelled = false;
    fetchProfile(userId)
      .then((profile) => {
        if (!cancelled && !profile.hasSeenTutorial) setOpen(true);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [active, userId]);

  const close = useCallback(() => {
    setOpen(false);
    // Флаг не сохранился (нет сети) — тур покажется ещё раз, это не страшно.
    markTutorialSeen().catch(() => undefined);
  }, []);

  return <AnimatePresence>{open && <TutorialModal onClose={close} />}</AnimatePresence>;
}
